"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const feedback_service_1 = require("./feedback.service");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
let FeedbackController = class FeedbackController {
    constructor(feedbackService) {
        this.feedbackService = feedbackService;
    }
    findAll(customerId) {
        return this.feedbackService.findAll(customerId ? parseInt(customerId, 10) : undefined);
    }
    findOne(id) {
        return this.feedbackService.findById(id);
    }
    create(body, user) {
        return this.feedbackService.create({
            customerId: body.customerId,
            orderId: body.orderId,
            collectedById: user.id,
        });
    }
    sendForm(id, body) {
        return this.feedbackService.sendForm(id, body.phone);
    }
    markFilled(id, body) {
        return this.feedbackService.markFormFilled(id, body.sentiment, body.feedbackText, body.rating);
    }
    sendFollowUp(id, body) {
        return this.feedbackService.sendFollowUp(id, body.phone);
    }
    addManagementRemarks(id, body) {
        return this.feedbackService.addManagementRemarks(id, body.remarks);
    }
    close(id, body) {
        return this.feedbackService.close(id, body.finalRemarks);
    }
};
exports.FeedbackController = FeedbackController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_READ),
    tslib_1.__param(0, (0, common_1.Query)('customerId')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], FeedbackController.prototype, "findAll", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], FeedbackController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, typeof (_d = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _d : Object]),
    tslib_1.__metadata("design:returntype", typeof (_e = typeof Promise !== "undefined" && Promise) === "function" ? _e : Object)
], FeedbackController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/send-form'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_SEND_FORM),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], FeedbackController.prototype, "sendForm", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/mark-filled'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_MARK_FILLED),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
], FeedbackController.prototype, "markFilled", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/follow-up'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_SEND_FOLLOW_UP),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], FeedbackController.prototype, "sendFollowUp", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/management-remarks'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_ADD_MANAGEMENT_REMARKS),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
], FeedbackController.prototype, "addManagementRemarks", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/close'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.FEEDBACK_CLOSE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
], FeedbackController.prototype, "close", null);
exports.FeedbackController = FeedbackController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('feedback'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof feedback_service_1.FeedbackService !== "undefined" && feedback_service_1.FeedbackService) === "function" ? _a : Object])
], FeedbackController);
